module.exports = __webpack_public_path__ + "img/zeplin.67d5e64.webp";